let global_callback = null
// 存储 WebSocket 连接.
let socket = ''
// 心跳定时器
let timeoutObj = null
// 服务超时定时关闭
let serverTimoutObj = null
// 是否真正建立了连接
let lockReconnect = false
// 重新连接的定时器，  没连接上会一直重连，设置延迟避免请求过多
let timeoutnum = null

const socketConfig = {
  url:process.env.API_URL.replace("https://","wss://").replace("http://","ws://")+"/websocket/",
  retryTimeout: 20000 // 心跳时间 暂定20s
}

export const sendWebsocket = function (agentData, callback) {
  global_callback = callback
  socketOnSend(agentData)
}

/**
 * 强制初始化
 * @param url
 */
export const forceInitWebSocket = function (url) {
  socket = ""
  initWebSocket(url)
}
export const initWebSocket = function (url) {
  let wsUrl = url || socketConfig.url + (localStorage.getItem('pro__userInfo') ? JSON.parse(localStorage.getItem('pro__userInfo')).value.id : '')
  if (!window.WebSocket) { return }
  if (!socket) {
    socket = new WebSocket(wsUrl)
    socketOnOpen()
    socketOnClose()
    socketOnError()
    socketOnMessage()
    lockReconnect = false
  }
}

/**
 * 关闭websocket函数
 */
export const closeWebsocket = function () {
  if (socket) {
    socket.close()
  }
  clearTimeout(timeoutObj)
  clearTimeout(serverTimoutObj)
}

export function reqWsParam(type, msgId) {
  return JSON.stringify({
    "cmd": type,
    "msgId": msgId,
    "userId":JSON.parse(localStorage.getItem('pro__userInfo')).value.id
  })
}

function socketOnSend(data) {
  if (!socket) {
    initWebSocket()
  } else if (socket.readyState !== WebSocket.OPEN) {
    lockReconnect = false
    reconnect()
  }
  socket.send(data)
}

function socketOnOpen() {
  socket.onopen = () => {
    console.log('socket连接成功')
    start()
  }
}

// 开启心跳
function start() {
  timeoutObj && clearTimeout(timeoutObj)
  serverTimoutObj && clearTimeout(serverTimoutObj)
  timeoutObj = setTimeout(() => {
    // 这里发送一个心跳，后端收到后返回一个心跳消息
    if (socket.readyState === 1 || socket.readyState == WebSocket.OPEN) {
      // 如果连接正常  给后端发送指定消息
      socket.send('0')
      console.log('心跳检测')
    } else {
      // 重连
      lockReconnect = false
      reconnect()
    }
    serverTimoutObj = setTimeout(() => {
      // 超时关闭连接
      socket.close()
    }, socketConfig.retryTimeout);
  }, socketConfig.retryTimeout);
}

// 重连
function reconnect() {
  if (lockReconnect) {
    return
  }
  lockReconnect = true
  socket = ""
  timeoutnum && clearTimeout(timeoutnum)
  timeoutnum = setTimeout(() => {
    initWebSocket()
  }, 5000);
}

function socketOnClose() {
  socket.onclose = (e) => {
    console.log('socket已经关闭')
    console.info('code:',e.code + 'reason:' + e.reason + 'clean:' + e.wasClean);

  }
}

function socketOnError() {
  socket.onerror = () => {
    lockReconnect = false
    reconnect()
    console.log('socket 连接失败')
  }
}

function socketOnMessage() {
  socket.onmessage = (e) => {
    if (e.data !== 'OK') {
      let data = eval("(" + e.data + ")");
      // console.log("接收到消息:",data)
      global_callback(data)
    }
    reset()
  }
}

// 重置心跳
function reset() {
  // 清除时间
  clearTimeout(timeoutObj)
  clearTimeout(serverTimoutObj)
  // 重启心跳
  start()
}



// WEBPACK FOOTER //
// ./src/utils/ws.js